import React, { type FC } from 'react';
import { Link as ReactRouterLink, type LinkProps } from 'react-router-dom';

import useEmbeddedLinkProps from '../hooks/use-embedded-link-props';
import { useNavigation } from '../navigation';

const EmbeddedLink: FC<LinkProps> = ({ children, to, onClick, ...props }) => {
  const linkProps = useEmbeddedLinkProps({ to, onClick });

  return (
    <ReactRouterLink {...props} {...linkProps}>
      {children}
    </ReactRouterLink>
  );
};

const Link: FC<LinkProps> = (props) => {
  const { isEmbedded } = useNavigation();
  const LinkComponent = isEmbedded ? EmbeddedLink : ReactRouterLink;

  return <LinkComponent {...props} />;
};

export default Link;
